const svgStyle = { display: 'block', width: 18, height: 18, fill: 'currentColor', flexShrink: 0 };

const IconList = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={svgStyle} aria-hidden="true">
        <rect x="3" y="7" width="2" height="2"/>
        <rect x="3" y="11" width="2" height="2"/>
        <rect x="3" y="15" width="2" height="2"/>
        <rect x="7" y="7" width="14" height="2"/>
        <rect x="7" y="11" width="14" height="2"/>
        <rect x="7" y="15" width="14" height="2"/>
    </svg>
);

const IconMap = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={svgStyle} aria-hidden="true">
        <polygon points="9,3 9,19 15,21 15,5"/>
        <polygon points="3,5 3,20 9,18 9,3"/>
        <polygon points="15,5 15,21 21,19 21,4"/>
    </svg>
);

const IconFilter = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={svgStyle} aria-hidden="true">
        <path d="M4 6h16v2H4zm3 5h10v2H7zm3 5h4v2h-4z"/>
    </svg>
);

function MobileBottomBar({
    mobileView,
    onMobileViewChange,
    onShowFilters,
    hasActiveFilters,
    activeFilterCount,
    showClear,
    onClear,
    showMap = true
}) {
    return (
        <div className="mobile-bottom-bar" role="tablist" aria-label="Mobile navigation">
            <button
                type="button"
                className={`bottom-tab ${mobileView === 'list' || !showMap ? 'active' : ''}`}
                onClick={() => onMobileViewChange('list')}
                role="tab"
                aria-selected={mobileView === 'list' || !showMap}
            >
                <IconList />
                <span>LIST</span>
            </button>

            {showMap && (
                <button
                    type="button"
                    className={`bottom-tab ${mobileView === 'map' ? 'active' : ''}`}
                    onClick={() => onMobileViewChange('map')}
                    role="tab"
                    aria-selected={mobileView === 'map'}
                >
                    <IconMap />
                    <span>MAP</span>
                </button>
            )}

            <button
                type="button"
                className={`bottom-tab ${hasActiveFilters ? 'has-active-filters' : ''}`}
                onClick={onShowFilters}
                role="tab"
                aria-label="Filters"
            >
                <IconFilter />
                <span>FILTERS</span>
                {hasActiveFilters && <span className="filter-badge" aria-label={`${activeFilterCount} active filters`}>{activeFilterCount}</span>}
            </button>
        </div>
    );
}

export default MobileBottomBar;
